import { render, staticRenderFns } from "./ThankYouStatic.vue?vue&type=template&id=677446e0&"
import script from "./ThankYouStatic.vue?vue&type=script&lang=js&"
export * from "./ThankYouStatic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports